import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Alert,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { LockOutlined, UpgradeOutlined } from '@mui/icons-material';
import { useAuthStore } from '../stores/useAuthStore';

const SubscriptionBanner: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { subscriptionStatus, isLoading } = useAuthStore();

  // Ne pas afficher le bandeau pendant le chargement initial ou si subscriptionStatus n'est pas encore chargé
  if (isLoading || !subscriptionStatus) {
    return null;
  }

  // Ne pas afficher le bandeau si l'utilisateur a un accès actif
  if (subscriptionStatus.hasActiveAccess) {
    return null;
  }

  const isInTrial = subscriptionStatus?.isInTrialPeriod || false;
  const daysRemaining = subscriptionStatus?.subscriptionDaysRemaining;

  return (
    <Alert
      severity="warning"
      icon={<LockOutlined />}
      sx={{
        mb: 2,
        bgcolor: '#FEF3C7',
        color: '#92400E',
        borderLeft: '4px solid #F59E0B',
        '& .MuiAlert-icon': {
          color: '#F59E0B',
        },
      }}
      action={
        <Button
          size={isMobile ? 'small' : 'medium'}
          variant="contained"
          startIcon={!isMobile && <UpgradeOutlined />}
          onClick={() => navigate('/subscription')}
          sx={{
            bgcolor: '#F59E0B',
            color: 'white',
            fontWeight: 600,
            '&:hover': {
              bgcolor: '#D97706',
            },
          }}
        >
          {isMobile ? 'Activer' : 'Activer l\'abonnement'}
        </Button>
      }
    >
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
          {isInTrial ? 'Période d\'essai' : 'Compte en mode lecture seule'}
        </Typography>
        <Typography variant="body2">
          {isInTrial ? (
            <>
              {daysRemaining !== null && daysRemaining !== undefined && daysRemaining >= 0 ? (
                <>Il vous reste <strong>{daysRemaining} jours</strong> pour profiter de toutes les fonctionnalités.</>
              ) : (
                <>Profitez de toutes les fonctionnalités pendant votre période d'essai.</>
              )}
            </>
          ) : (
            <>Activez votre abonnement pour créer et modifier des documents.</>
          )}
        </Typography>
      </Box>
    </Alert>
  );
};

export default SubscriptionBanner;
